export type RequestType<T> = {
	code: number;
	msg: string;
	data: T;
};

// 权限
export type PermissionsType = {
	deepfake: Extract<FileType, 0 | 1 | 2>[];
	diffusion: Extract<FileType, 0>[];
	diffusion_full_frame: Extract<FileType, 0 | 1>[];
	llm: Extract<FileType, 4>[];
	image_class: Extract<FileType, 0>[];
	video_class: Extract<FileType, 1 | 2>[]; //1=有视频检测， 2=有音频检测
	composite:[];  //综合检测
	synchronizeAudio?: boolean;   //综合检测 - 同时检测音频
};

// 数据类型 枚举
export enum FileTypeEnum {
	IMAGE, // 图片
	VIDEO, // 视频
	AUDIO, // 音频
	TEXT, // 文本
}

// 数据类型
export type FileType =
	| 0 // 图片
	| 1 // 视频
	| 2 // 音频
	| 3; // 文本

export const FILE_TYPE_CONFIG: Record<
	FileTypeEnum,
	{ text: string; value: FileTypeEnum; valueText: string; label: string }
> = {
	[FileTypeEnum.IMAGE]: {
		text: "图片",
		label: "图片",
		value: FileTypeEnum.IMAGE,
		valueText: "image",
	},
	[FileTypeEnum.VIDEO]: {
		text: "视频",
		label: "视频",
		value: FileTypeEnum.VIDEO,
		valueText: "video",
	},
	[FileTypeEnum.AUDIO]: {
		text: "音频",
		label: "音频",
		value: FileTypeEnum.AUDIO,
		valueText: "audio",
	},
	[FileTypeEnum.TEXT]: {
		text: "文本",
		label: "文本",
		value: FileTypeEnum.TEXT,
		valueText: "text",
	},
};

export const FileTypeHash = {
	0: FILE_TYPE_CONFIG[FileTypeEnum.IMAGE].valueText,
	1: FILE_TYPE_CONFIG[FileTypeEnum.VIDEO].valueText,
	2: FILE_TYPE_CONFIG[FileTypeEnum.AUDIO].valueText,
	3: FILE_TYPE_CONFIG[FileTypeEnum.TEXT].valueText,
};

// 检测类型 枚举
export enum DetectionEnum {
	DEEPFAKE, // 深度伪造检测
	DIFFUSION, // AIGC检测
	LLM, // 大模型文本检测
	DIFFUSIONFULLIMAGE, // AIGC全画幅检测
	IMAGECLASS, // 图片检测大类
	VIDEOCLASS, // 视频检测大类
	COMPOSITECHECK, //综合检测
	// COMPOSITECHECK=6, //综合检测
}

// 检测状态 枚举
export enum DetectionStatusEnum {
	DETECTING = 1, // 检测中
	SUCCESS, // 检测成功
	FAIL, // 检测失败
}

// 检测状态
export type DetectionStatusType =
	| 1 // 检测中
	| 2 // 检测成功
	| 3; // 检测失败

// 检测结果 枚举 (图片、视频、音频)
export enum DetectionResultEnum {
	FALSE = 1, // 假
	TRUE, // 真
	NOT_DETECTED, //图片、视频： 未检测到人脸 音频：未检测到人声
	// FAIL // 检测失败
	IMAGE_VIDEO_CLASS_TRUE = 17, // 图像、视频检测大类 真实
	IMAGE_VIDEO_CLASS_FALSE = 18, // 图像、视频检测大类 伪造

	// 检测报告
	// 检测音频的视频，音频检测结果：三类情况
	VIDEO_CLASS_DETECT_AUDIO_FALSE = 24, // 视频含有AI生成人声
	VIDEO_CLASS_DETECT_AUDIO_TRUE = 25, // 视频不含AI生成人声
	VIDEO_CLASS_DETECT_AUDIO_NOT_DETECTED = 21, // 视频不含人声

	// list里面的视频含有AI生成人声  AI, {10%}"、视频含有AI生成人声  AI"
	// LIST_VIDEO_CLASS_DETECT_AUDIO_FALSE_PERSENT = 18,
	LIST_VIDEO_CLASS_DETECT_AUDIO_FALSE = 19,
}

// 检测结果 (图片、视频、音频)
export type DetectionResultType =
	| 1 // 假
	| 2 // 真
	| 3 // 未检测到人脸
	| 17 // 图像、视频检测大类 真实 | 视频不含AI生成人声" 非AI  => list所用
	| 18 // 图像、视频检测大类 伪造 | 视频含有AI生成人声  AI, {10%}" => list所
	| 21 // 视频不含人声"
	| 22 // AI生成的可能性{0}%"
	| 23 // 不含AI的可能性{0}%"
	| 24 // 视频含有AI生成人声" // 检测报告所用
	| 25 // 视频不含AI生成人声" // 检测报告所用
	| 18 // 视频含有AI生成人声  AI, {10%}"  // list所用
	| 19 // 视频含有AI生成人声  AI"  // list所用
	| 20; // 视频不含AI生成人声" 非AI // list所用
// | 4; // 检测失败

// 检测结果 枚举 (文本)
export enum TextDetectionResultEnum {
	FALSE = 1, // 合成文本
	TRUE, // 人类文本
	// FAIL // 检测失败
}

// 检测结果 (文本)
export type TextDetectionResultType =
	| 1 // 合成文本
	| 2; // 人类文本
// | 4; // 检测失败

// 报告类型
export enum ReportEnum {
	VIDEO,
	IMAGE,
}

// 检测类型
export const DetectionCodeDict = {
	// 深度伪造检测
	0: "deepfake",
	// AIGC检测
	1: "diffusion",
	// 大模型文本检测
	2: "llm",
	// AIGC全画幅检测
	3: "diffusion_full_frame",
	// 图片检测大类
	4: "image_class",
	// 视频检测大类
	5: "video_class",
	// 综合检测
	6: "composite"
};

export type DetectionType = keyof typeof DetectionCodeDict;

export const DetectionTypeDict = {
	deepfake: {
		defaultText: "Deepfake检测",
		label: "Deepfake",
		value: 0,
	},
	diffusion: {
		defaultText: "Diffusion人脸检测",
		label: "Diffusion人脸",
		value: 1,
	},
	llm: {
		defaultText: "LLM检测",
		label: "LLM",
		value: 2,
	},
	diffusion_full_frame: {
		defaultText: "Diffusion全画幅检测",
		label: "Diffusion全画幅",
		value: 3,
	},
	image_class: {
		defaultText: "图像检测大类",
		label: "图像检测大类",
		value: 4,
	},
	video_class: {
		defaultText: "视频检测大类",
		label: "视频检测大类",
		value: 5,
	},
	composite: {
		defaultText: "综合检测",
		label: "综合检测",
		value: 6,
	}
};

export const statusOptions = [
	{ label: "检测中", value: 1 },
	{ label: "检测成功", value: 2 },
	{ label: "检测失败", value: 3 },
];
export const resultsOptions = [
	{ label: "非AI", value: "0" },
	{ label: "AI", value: "1" },
];
